export default {
  getMetricsUrlParams(metrics) {
    var params = [];

    for (var k in metrics) {
      if (Array.isArray(metrics[k])) {
        params.push(`${k}=${metrics[k].join(",")}`);
      } else {
        params.push(`${k}=${metrics[k]}`);
      }
    }

    return "?" + params.join("&");
  }
};
